import React, { Fragment } from "react";

import {
  Box,
  Button,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { Save as SaveIcon } from "react-feather";

import { default as BaseModal } from "@ds-developer/modal";
import { formatDistance } from "@ds-developer/frontend";

import { UpdateMileageModalProps } from "./types";

const useStyles = makeStyles(theme => ({
  box: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
}));

const UpdateMileageModal: React.FC<UpdateMileageModalProps> = ({
  onDiscardClick = () => {},
  onSaveClick = () => {},
  onChange = () => {},
  handleMileageInputClick = () => {},
  mileage,
  registration,
  disabled = false,
}) => {
  const classes = useStyles();

  const actions = (
    <Fragment>
      <Button onClick={onDiscardClick} variant="outlined">
        Discard
      </Button>
      <Button
        onClick={onSaveClick}
        variant="contained"
        color="secondary"
        startIcon={<SaveIcon size={16} />}
        disabled={disabled}
        data-test="update-mileage-save"
      >
        Save
      </Button>
    </Fragment>
  );

  return (
    <BaseModal
      actions={actions}
      open
      title={`Update mileage for ${registration}`}
    >
      <Box className={classes.box}>
        <Typography variant="body2" color="textSecondary">
          Last update:{" "}
          {mileage
            ? formatDistance(
                new Date(mileage?.captureDate),
                new Date(Date.now()),
              )
            : ""}
        </Typography>
      </Box>

      <TextField
        fullWidth
        label="Mileage"
        value={mileage?.value || "0"}
        onChange={onChange}
        onClick={handleMileageInputClick}
        variant="outlined"
        data-test="update-mileage-input"
      />
    </BaseModal>
  );
};

export default UpdateMileageModal;
